import { httpInstance } from '@/services/httpInstance';

const updateFeaturesFlagCommerceService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/features-flag-commerce';
  const dataSent = dataParam;

  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateFeaturesFlagCommerceService;
